// extracted by mini-css-extract-plugin
export default {"title":"ken2q0z3","isInline":"poh6Mp6L","inlineLink":"PctWdv0L"};